import { useEffect, useState } from 'react';
import { DESC, Filter } from 'framework/list';
import { NotificationCard, NotificationCardProps } from 'framework/ui/layout';
import { Theme } from '@mui/material/styles';
import { SystemStyleObject } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import { useLeadUrl } from 'domain/shared/lead';

type LeadNotificationButtonProps<TResponse> = {
  getLabel: (data: TResponse) => string;
  state: Filter;
  response: TResponse;
  styles?: SystemStyleObject<Theme>;
  sx?: SystemStyleObject<Theme>;
} & Omit<NotificationCardProps, 'title' | 'onClick' | 'sx'>;

const LeadNotificationButton = <TResponse,>({
  getLabel,
  state,
  styles,
  sx,
  response,
  icon,
  description,
  ...props
}: LeadNotificationButtonProps<TResponse>) => {
  const [label, setLabel] = useState('');
  const navigate = useNavigate();
  const { getListUrl } = useLeadUrl();

  const loadData = (responseData: TResponse) => {
    setLabel(getLabel(responseData));
  };

  useEffect(() => {
    if (response) {
      loadData(response);
    }
    // Suppressed warnings because we only need to call useEffect callback ones after the first mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response]);

  const onClick = () => {
    navigate(`${getListUrl()}?sortBy=updatedAt&sortOrder=${DESC}&filter=${JSON.stringify(state)}`, { replace: true });
  };

  return (
    <NotificationCard
      onClick={onClick}
      title={label}
      description={description}
      icon={icon}
      actionLabel="Open leads"
      sx={{ ...styles, ...sx }}
      {...props}
    />
  );
};

export default LeadNotificationButton;
